import Listicon from '../../../assets/images/listicon.svg';
import logo from '../../../assets/images/logo.png';
import './Large.scss';

const Large = ({ plans, selectedPlan, handleChangePlan }) => {
    const totalPlans = plans.length;
    return (
        <div className="row pricing-large">
            {plans.map(plan => {
                const isCurrentPlan = plan.id === selectedPlan;

                return (
                    <div className={`col-12 col-lg-${12/totalPlans}`}>

                        <div className="pricing bg-blush-white h-full bc-bright-red br-100 bw-25 mx-100" style={{ 'box-shadow': '0px 0 4px rgba(0,0,0,0.4)' }}>

                            <div className="brand-holder bg-bright-red flex jc-center ai-center">
                                <div className="brand-image" style={{ 'background-image': `url(${logo})` }}></div>
                            </div>

                            <div className="pb-1200 relative" style={{ height: 'calc( 100% - 64px )' }}>

                                <h5 className="text-bright-red text-center fs-300 lh-300 py-300 ff-inter-bold fw-bold"
                                    style={{ 'text-shadow': 'rgba(0, 0, 0, 0.1) 1px 0px 4px' }}>{plan.name}</h5>

                                <h4 className="text-center text-black fs-700 lh-700 pb-100"

                                    style={{ 'text-shadow': '1px 0 8px rgba(0, 0, 0, 0.2)' }}>₹{Math.trunc(plan.price)}<span className="fs-200">/{plan.billingCycle}</span></h4>
.
                                <h5 className="ff-inter-medium text-center fs-200 lh-200 text-black"
                                    style={{ 'text-shadow': '1px 0 2px rgba(0, 0, 0, 0.2)' }}
                                >{plan.noOfEntries} Free entries</h5>

                                <div className='pricingfeatures px-300 mt-500'>
                                    {plan.features.map(feature => {
                                        return (<p className="pl-300 relative mb-100 ff-inter"> <img src={Listicon} alt="" className="s-200 absolute l-0 t-50" /> {feature} </p>)
                                    })}
                                </div>

                                <a className={`btn-primary absolute l-300 b-300 ${!isCurrentPlan ? '' : 'op-3 cr-not-allowed'}`} href="javascript:;" onClick={() => !isCurrentPlan && handleChangePlan(plan)}>
                                    {isCurrentPlan ? 'Current Plan' : `Choose ${plan.name}`}
                                </a>

                            </div>

                        </div>

                    </div>
                );
            })}

        </div>
    );
};

export default Large;